export enum LanguagesEnum {
  Greek = 'Greek',
  English = 'English',
}

export default {
  ...LanguagesEnum,
  All: Object.values(LanguagesEnum),
};
